<template>
  <Modal>
    <template slot="modal__button" slot-scope="{didOpen}">
      <div class="shadow-sm rounded-md">
        <button
          @click="didOpen"
          class="inline-flex items-center px-2 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 transition duration-150 ease-in-out cursor-pointer"
          :class="{'text-gray-800 bg-gray-50': hasTranslated}"
          tabindex="2"
        >
          <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <use href="/images/regular.svg#globe-americas"></use>
          </svg>
        </button>
      </div>
    </template>
    <template slot="modal__body" slot-scope="{didClose}">
      <div>
        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
            Pick a Language
          </h3>
          <div class="mt-2">
            <p class="text-sm leading-5 text-gray-500">
              Families will recieve the translation (not your original)
            </p>
          </div>
        </div>
      </div>
      <div class="mt-6">
        <div class="mt-1 rounded-md shadow-sm">
          <select id="proposedHomeLanguage" class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" v-model="proposedHomeLanguage">
            <option v-for="homeLanguage in homeLanguages" :value="homeLanguage" :key="homeLanguage.id">
              {{homeLanguage.name}}
            </option>
          </select>
        </div>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="didClickTranslate(didClose)"
            >
            Translate
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="undidTranslate(didClose)"
            v-if="hasTranslated"
          >
            Undo Translation
          </button>
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="didClose"
            v-else
          >
            Cancel
          </button>
        </span>
      </div>
    </template>
  </Modal>
</template>

<script>
import _get from 'lodash-es/get'

import ButtonSubmit     from '@/components/ButtonSubmit.vue'
import Modal            from '@/components/Modal.vue'
import TranslationQuery from '@/queries/Translation.gql'
import { queryHandler }  from '@/responseHandler'


export default {
  components: {
    ButtonSubmit,
    Modal
  },

  props: {
    body: {
      type: String
    },
    hasTranslated: {
      type: Boolean,
      required: true
    },
    homeLanguages: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      isTranslating: false,
      proposedHomeLanguage: null,
      translationErrors: []
    }
  },

  computed: {
    proposedHomeLanguageId() {
      return _get(this, 'proposedHomeLanguage.id')
    },

    proposedHomeLanguageName() {
      return _get(this, 'proposedHomeLanguage.name')
    },

    shouldSkipTranslation() {
      return (this.body == '')
        || (this.proposedHomeLanguage == null)
        || (this.body == null)
    }
  },

  methods: {
    didClickTranslate(closeModalCallback) {
      if (this.shouldSkipTranslation) {
        this.proposedHomeLanguage = null
        closeModalCallback()
      } else {
        this.didTranslate(closeModalCallback)
      }
    },

    didTranslate(closeModalCallback) {
      this.isTranslating = true

      queryHandler({
        apollo: this.$apollo,
        component: 'TranslationModalInput',
        query: 'TranslationQuery',
        queryOpts: {
          query: TranslationQuery,
          variables: {
            original: this.body,
            homeLanguageId: _get(this.proposedHomeLanguage, 'id')
          }
        },
        onSuccess: (data) => {
          this.$emit('input', {
            homeLanguage: this.proposedHomeLanguage,
            translatedBody: data.translation.translation,
            hasTranslated: true
          })
          this.isTranslating = false
          closeModalCallback()
        },
        onErrors: (errors) => {
          this.translationErrors = errors
          this.isTranslating = false
        },
        onError: (error) => {
          this.translationErrors = [error],
          this.isTranslating = false
        }
      })
    },

    undidTranslate(callback) {
      callback()
      this.proposedHomeLanguage = null
      this.$emit('input', {homeLanguage: null, translatedBody: null, hasTranslated: false})
    }
  }
}
</script>
